import React from 'react'

export default function Checkbox({
  label,
  name,
  checked = false,
  onChange = () => {}
}) {
  return (
    <div className="flex items-center">
      <input
        className="
          text-rb-green
          mr-2
          focus:outline-0
          focus:border-2
          focus:border-rb-green
          focus:ring-transparent
          focus:ring-offset-transparent
          border-1
          border-rb-black
          rounded-sm
          shadow
        "
        id={name}
        name={name}
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />

      <label htmlFor={name}>{label}</label>
    </div>
  )
}
